export default __webpack_public_path__ + "static/media/cactus2.faa58160.png";